import { compose, lifecycle, withState, withProps } from 'recompose'

export default () => compose(
  // warning! store may conflict with store (redux)
  // cannot put connect hoc below this hoc
  withState('storeData', 'setStoreData', ({ storeDetail }) => storeDetail),
  withProps(({ storeData, setStoreData, storeDetail }) => ({
    setName: (name) => setStoreData({ ...storeData, name }),
    setImage: (image) => setStoreData({ ...storeData, image }),
    setIsActive: (isActive) => setStoreData({ ...storeData, isActive }),
    setAddress: (address) => setStoreData({ ...storeData, address }),
    setPhone: (phone) => setStoreData({ ...storeData, phone }),
    setLocation: (location) => setStoreData({ ...storeData, location }),
    setTags: (tags) => setStoreData({ ...storeData, tags }),
    setType: (type) => setStoreData({ ...storeData, type }),
    setMapUrl: (mapUrl) => setStoreData({ ...storeData, mapUrl }),
    setOpenHours: (openHours) => setStoreData({ ...storeData, openHours }),
    onDiscard: () => setStoreData(...storeDetail),
  })),
)



// WEBPACK FOOTER //
// ./src/pages/StoreLocator/hocs/withStore.js